import axios from "axios";

export const API_CONSTANTS = {
  MAX_RETRY_ATTEMPTS: 3,
  TIMEOUT: 1000 * 60 * 5, // 5 minutes
  STALE_TIME: 0, // 1 minute, this defines how long the data is considered fresh, after which it will be refetched on mount
  /**
   * gcTime is a memory management feature. It prevents the cache from growing indefinitely by ensuring that data no longer being actively used is eventually cleaned up.
   *
   * A query becomes "inactive" when there are no more active useQuery or other observer instances subscribed to it (i.e., when all components using that query have unmounted).
   */
  GC_TIME: 1000 * 60 * 2, // 2 minutes

  PREFETCH_ADDITIONAL_PAGE_COUNT: 1, // Number of pages to prefetch ahead
};

export const checkIfClient = (decodeToken) =>
  Boolean(decodeToken?.ClientId && decodeToken?.ClientId !== 9999);

export const retryAttempt = (failureCount, error) => {
  if (axios.isCancel(error)) {
    return failureCount < API_CONSTANTS.MAX_RETRY_ATTEMPTS; // Retry up to 3 times
  }

  // Do not retry if 4xx error
  if (error?.response?.status >= 400 && error?.response?.status < 500) {
    return false;
  }

  // Retry for other errors (e.g., network issues, 5xx errors)
  return failureCount < API_CONSTANTS.MAX_RETRY_ATTEMPTS; // Retry up to 3 times
};

export const TABLE_MODE_OPTIONS = {
  SERVER: "server",
  CLIENT: "client",
};

export const queryKeys = {
  ALL_ORDERS: ["deliveryAllOrders"],
  ALL_ORDERS_BY: (category, key) =>
    key
      ? ["deliveryAllOrders", category, key]
      : ["deliveryAllOrders", category],

  DELIVERY_HISTORY: ["deliveryOrderHistory"],
  DELIVERY_HISTORY_BY: (category, key) =>
    key
      ? ["deliveryOrderHistory", category, key]
      : ["deliveryOrderHistory", category],

  STATUS_ORDERS: ["orderStatus"],
  STATUS_ORDERS_BY: (category, key) =>
    key ? ["orderStatus", category, key] : ["orderStatus", category],
};

// This object is used to differentiate between different rendering modes for the orders and statuses. It helps in determining how the data should be fetched and displayed based on whether it's server-side rendered (SSR) or client-side rendered (CSR).
export const RENDER_MODE = {
  SSR: 1,
  CSR: 2,
};

export const addPendingReturnOrderStatus = (orders, returnRequestList) => {
  if (!orders || (Array.isArray(orders) && !Array.isArray(returnRequestList))) {
    return [];
  }

  const ordersWithReturnStatus = orders.map((order) => {
    const returnRequests =
      returnRequestList?.filter(
        (returnRequest) => returnRequest?.deliveryId === order?.deliveryId,
      ) || [];

    if (returnRequests.length > 0) {
      const hasPendingReturn = returnRequests.some(
        (request) => !request?.isImported && !request?.isDenied,
      );

      return {
        ...order,
        returnRequestStatuses: hasPendingReturn,
      };
    }

    return order;
  });

  return ordersWithReturnStatus;
};
